import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8025_11874)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11.5002 5H2.50024V14H11.5002V5Z",
			stroke: "#0000EE",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.50024 3H13.5002V12",
			stroke: "#0000EE",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8025_11874",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.000244141 0.5)"
		})
	}) })]
});
export default SvgCopy;
